import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  container: {
    padding: "40px 0px 15px 0px",
  },
  fullrowItem: {
    width: "100%",
    marginBottom: "20px",
  },
  gap: {
    marginTop: "10px",
  },
}));
